export enum DateRangeEnum {
    Today,
    Week,
    Month,
    Quartal,
    Year,
    AllTime,
    CustomRange
}


export interface DateRangeProps {
    start: string;
    end: string;
}

export interface EnumToRangeProps {
    dateRange: DateRangeEnum;
    start?: Date;
    end?: Date;
}


export interface DateRangeComponentProps {
    isOpen: boolean;
    dateRange: DateRangeEnum;
    setDateRangeOpen: (isOpen:boolean) => void;
    setDateRange: (dateRange: DateRangeProps) => void;
    options?: Array<DateRangeEnum>
}


export type RangeHandlerParams = {
    isOpen: boolean;
    range: DateRangeEnum;
    rangeProps: DateRangeProps | null;
}